import { css } from '@emotion/css';

export const browserWarningDialog = css`
  text-align: center;

  .MuiDialogTitle-root {
    padding: 20px 24px 20px 24px !important;
  }

  .MuiDialogContent-root {
    padding: 0px 24px !important;
  }
`;

export const browserWarningDialogTitle = css`
  font-size: 16px;
  padding-bottom: 0px;
`;

export const browserWarningDialogContent = css`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #5e5e5e;
  padding-top: 0px;
  padding-bottom: 0px;
`;
